import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';
import styles from './textarea.css';

const MAX_LENGTH = 200;

export const Textarea = ({ Text, onChange, placeholder, questionText, value }: IProps) => (
    <div>
        <Text
            className={cn(styles.text, styles.external)}
            styler={{ margin: 0, paddingLeft: 32, paddingRight: 32 }}
            view="action-primary-medium"
        >
            <span>{questionText}</span>
        </Text>
        <textarea
            className={styles.textarea}
            data-test-id="feedback-form-textarea"
            maxLength={MAX_LENGTH}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            value={value}
        />
        <div className={styles.textareaHelpText}>
            {value ? `${value.length}/${MAX_LENGTH} символов` : `Максимум ${MAX_LENGTH} символов`}
        </div>
    </div>
);
